export default __webpack_public_path__ + "static/media/blog-3.e07746fd.jpg";